import * as React from "react";
import { Chip, TextField } from "@mui/material";
import { Box } from "@mui/system";
import SpecialityService from "../../features/speciality/specialityService";
import AppForm from "../forms/AppForm";
import FormInput from "../forms/FormInput";
import { addSpecilitiesTagValidationSchema } from "../forms/validationSchemas";
import AppButton from "../common/AppButton";

interface IProps {
  handleClose: () => void;
  speciality: any;
  getCall: any;
}

const SpecialityTags = ({ speciality }: IProps) => {
  const [formState, setFormState] = React.useState({
    speciality_id: speciality?.id,
    tag: "",
  });
  const [chips, setchip] = React.useState<any>([]);
  function getTagsList() {
    SpecialityService.getTags(speciality?.id).then((response) => {
      setchip(response?.data[0]?.tags);
    });
  }
  /* UseEffect*/
  React.useEffect(() => {
    getTagsList();
  }, []);

  const handleTagSubmit = (values: any, { resetForm }: any) => {
    SpecialityService.AddTags({
      speciality_id: speciality?.id,
      tags: values.tag,
      tags_id: "",
    }).then((responce) => {
      if (responce.success === true) {
        resetForm({
          speciality_id: speciality?.id,
          tag: "",
        });
        getTagsList();
      }
    });
  };

  const handleDelete = (tag_id: any) => {
    SpecialityService.DeleteTags({
      speciality_id: "speciality?.id",
      tags: "values.tag",
      tags_id: tag_id.id,
    }).then(async (res) => {
      if (res.payload.success === true) {
      }
    });
  };

  return (
    <>
      <AppForm
        validationSchema={addSpecilitiesTagValidationSchema}
        initialValues={formState}
        onSubmit={handleTagSubmit}
      >
        <Box
          sx={{
            width: "100%",
            mt: 3,
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            p: 2,

            marginTop: "-30px",
          }}
        >
          <FormInput
            name="tag"
            as={TextField}
            label="Tag"
            values="tag"
            fullWidth
          ></FormInput>{" "}
          {/* ..............................................................Button of Add Tags.............................................................. */}
          <Box>
            <AppButton title="Add" sx={{ float: "right", margin: "10px" }} />
          </Box>
        </Box>
        {/* ..............................................................Specialties Chips Tags.............................................................. */}

        {chips?.map((item: any) => (
          <Chip
            style={{
              margin: "10px",
              color: "black",
              marginLeft: "10px",
              marginBottom: "10px",
            }}
            key={item.id}
            label={item.tags}
            color={"default"}
            variant={"outlined"}
            onDelete={() => {
              handleDelete(item);
              getTagsList();
            }}
          />
        ))}
      </AppForm>
    </>
  );
};

export default SpecialityTags;
